import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Clickhouse = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Clickhouse"
    height={height}
    width={width}
    title="Clickhouse logo"
    titleId="clickhouse-logo-title"
    viewBox="0 0 512 512"
    {...props}
  >
    <g>
      <path d="M0,426.7h56.9v56.9H0V426.7z" fill="#FF0000" />
      <path
        d="M0,28.4h56.9v398.2H0V28.4z M113.8,28.4h56.9v455.1h-56.9V28.4z M227.6,28.4h56.9v455.1h-56.9V28.4z    M341.3,28.4h56.9v455.1h-56.9V28.4z M455.1,213.3H512v85.3h-56.9V213.3z"
        fill="#FFCC00"
      />
    </g>
  </SvgIcon>
);
